import { Injectable, Input } from '@angular/core';
import { each } from 'lodash';
import { AccordionCardCollection } from 'src/app/interfaces/accordion-card-collection';

import { Card } from '../../../../interfaces/card';
import { CardColumnBase } from '../card-column-base';

@Injectable()
export abstract class CardColumnAccordionDisplayBase extends CardColumnBase {
  constructor() {
    super();
  }

  // Can pass in a custom filter function to handle filtering the accordion display.
  @Input() filterFunction?: (filterText: string) => void;

  // Collection (array) of accordionCardCollection objects. These are used to display an accordion header
  // and a Card Collection in an accordion body when opened.
  accordionCardCollectionArray: AccordionCardCollection[] = [];

  // Activated when a user types text into the filter bar at the top of the modal.
  override filter(text: string) {
    if (this.filterFunction) {
      this.filterFunction(text);
    } else {
      // Utilize case insensitivity when performing filtering.
      const formattedFilterText = text.toLowerCase();
      each(
        this.accordionCardCollectionArray,
        (accordionCardCollection: AccordionCardCollection) => {
          const { cardCollection } = accordionCardCollection;
          each(cardCollection, (card: Card) => {
            if (
              card.bodyText &&
              !card.bodyText.toLowerCase().includes(formattedFilterText)
            ) {
              card.isHidden = true;
            } else if (
              card.title &&
              !card.title.toLowerCase().includes(formattedFilterText)
            ) {
              card.isHidden = true;
            } else {
              card.isHidden = false;
            }
          });
        }
      );
    }
  }

  override clearFilter() {
    each(
      this.accordionCardCollectionArray,
      (accordionCardCollection: AccordionCardCollection) => {
        const { cardCollection } = accordionCardCollection;
        each(cardCollection, (card: Card) => {
          card.isHidden = false;
        });
      }
    );
  }
}
